import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./i18n";

import HomePage from "./pages/homePage";
/* import AboutUs from "./pages/aboutUs"; */
import Certifications from "./pages/certifications";
import Imprint from "./pages/imprint";
import Portfolio from "./pages/portfolio";
import Privacy from "./pages/privacy";
import Production from "./pages/production";
import Team from "./pages/team";
import Error404 from "./pages/error404";
import Tracking from "./components/tracking/Tracking";
import ConfiguratorWrapper from "./components/configurator/ConfiguratorWrapper";

import Header from "./layout/header";
import Footer from "./layout/footer";

import "react-toastify/dist/ReactToastify.css";

// icons
import "./assets/plugins/keenthemes-icons/font/ki.css";
import "./assets/plugins/flaticon/flaticon.css";
import "./assets/plugins/flaticon2/flaticon.css";
import "./assets/plugins/line-awesome/css/line-awesome.min.css";

import "./index.scss";

import "../src/assets/css/font-icons.min.css";
import "../src/assets/css/bootstrap.min.css";
import "../src/assets/css/swiper.min.css";
import "../src/assets/css/justified-gallery.min.css";
import "../src/assets/css/animate.min.css";
import "../src/assets/css/magnific-popup.min.css";
import "../src/assets/css/custom-scrollbar.min.css";
import "../src/assets/css/animated-headlines.min.css";
import "../src/assets/css/jquery-ui.min.css";
import "../src/assets/css/responsive.css";
import "../src/assets/css/style.css";
import "../src/assets/css/custom.css";
import {ReactSVG} from "react-svg";


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      shouldRender: true,
    };}


  componentWillUnmount() {
    clearTimeout(this.timer); // Bereinigung, um Memory Leaks zu vermeiden
  }
  componentDidMount() {
    // load js scripts AFTER rendering
    let script = document.createElement("script");
    script.src = "scripts.js";
    script.id = "scripts";
    document.body.appendChild(script);
    this.timer = setTimeout(() => {

        this.setState({ isVisible: false });

    }, 1000); // 1000 ms = 1 Sekunde
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.isVisible && !this.state.isVisible) {
      setTimeout(() => {
        this.setState({ shouldRender: false });
      }, 500); // Wartezeit entsprechend der Dauer der Fade-Out-Animation
    }
  }
  download(param) {
    console.log("param: ", param);

    switch (param) {
      case "aeb":
        param = "GB-AEB-0001";
        break;
      case "avlb":
        param = "GB-AVLB-0001";
        break;
      case "agb":
        param = "GB-AGB-0001";
        break;
      default:
        break;
    }

    fetch("pdf/" + param + ".pdf", {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", param + `.pdf`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });
  }



  render() {
    const { isVisible, shouldRender } = this.state;
    return (
      <React.Suspense fallback="loading...">
        {shouldRender ? <div className={` splash ${!isVisible ? 'fadeout' : ''}`}><ReactSVG src="images/logo-dark.svg" style={{ width: "160px" }} /></div> : null}
        <div className={"App " }>

          <Router><Header />
            <ToastContainer limit={2} />
             <Switch>

              {/* <Route path="/about-us">
                <AboutUs />
              </Route> */}
              <Route path="/certifications">
                <Certifications />
              </Route>
              <Route path="/configurator" component={ConfiguratorWrapper} />
              <Route path="/imprint">
                <Imprint />
              </Route>
              <Route path="/portfolio">
                <Portfolio />
              </Route>
              <Route path="/privacy">
                <Privacy />
              </Route>
              <Route path="/production">
                <Production />
              </Route>
              <Route path="/team">
                <Team />
              </Route>
              <Route path="/tracking" component={Tracking} />

              <Route path="/agb">{() => this.download("agb")}</Route>
              <Route path="/avb">{() => this.download("avlb")}</Route>
              <Route path="/aeb">{() => this.download("aeb")}</Route>

              <Route path="/">
                <HomePage />
              </Route>
              <Route path="*">
                <Error404 />
              </Route>
            </Switch>
          </Router>
          <Footer />
        </div>
      </React.Suspense>
    );
  }
}

export default App;
